export const showAddArticleModal = () => {
    return {
      type: "SHOW_ADD_ARTICLE_MODAL",
    };
  };
  
  export const hideAddArticleModal = () => {
    return {
      type: "HIDE_ADD_ARTICLE_MODAL",
    };
  };
  